export const DEFAULT_FIBRETRACE_ADDRESS = "Level 42, 6 Battery Rd, Singapore 049909"
export const DEFAULT_FIBRETRACE_GEO = {
    lat: 1.285631,
    lng: 103.8517833
}

export const DEFAULT_AUDIT_DEADLINE = '2099-01-01';

export const DEFAULT_APP_CONFIG = {
    app_name: "Fibretrace",
    audit_media_accepted_file_extension: "image/jpg, image/jpeg, image/png",
    audit_attached_file_accepted_extension: "image/jpg, image/jpeg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword",
    audit_media_max_number_of_file: "20",
    audit_media_max_upload_file_size: "1",
    datetime_format: "d/M/Y G:ia",
    minimum_search_character: "3",
    missmatch_location_distance: "1000",
    notification_refresh_interval: 60000,
    order_scanner_label: 'LABEL.SCANNER_STATUS_ORDER',
    order_scanner_allowed: false,
    frequency_of_scan: 10,
    frequency_of_scan_period: 1000,
    zendesk_help_url: "https://fibretracesupport.zendesk.com/hc/en-us",
    webapp_policy_url: "https://www.fibretrace.io/webapp-privacy-policy"
}


export const DEFAULT_VARIABLES = {
    SEARCH_SETTINGS: {
        selected: "",
        queries: {
            page: 1 as number,
            number_per_page: 5 as number,
            status: null as any,
            search: null as any,
            keyword: null as any,
            sort: null as any,
            sort_by: null as any,
        },
        pagingData: {
            current_page: 1,
            from: "",
            last_page: "",
            path: "",
            per_page: 5,
            to: "",
            total: "",
            total_pages: "" as (Number | string)
        }
    }
}


export const DEFAULT_SELECT = {
    isDisabled: true,
    isLoading: true,
    isClearable: false,
    isSearchable: true,
    list: [] as any,
    selected: "" as any,
};

export const DEFAULT_PRODUCT_DATA = {
    id: "" as any,
    name: "" as any,
    description: "" as any,
    manufacturer_name: "" as any,
    manufacturer_company_id: "" as any,
    images: [] as any,
    uploaded_images: {} as any,
    file: "" as any,
    attributeTemplateValue: "" as any,
}

export const DEFAULT_PRODUCT_TEMPLATE_DATA = {
    can_be_deleted: false as any,
    content: "" as any,
    id: "" as any,
    is_public: 1 as any,
    name: "" as any,
    status: 1 as any,
    uid: "" as any,
}

export const DEFAULT_AUDIT_SUMMARY = {
    process_manufacturer_name: '',
    process_manufacturer_url: '',
    process_lat: '',
    process_long: '',
    process_location: '',
    process_name: '',
    process_scanned_date: null,
    process_scanned_by: '',
    process_due_date: '',
    order_code: '',
    product_image: '',
    prev_process_id: null,
    next_process_id: null,
} as any;

export const DEFAULT_SOCIALS_SELECT = [
    {label: "Choose network", value: ""},
    {label: "LinkedIn", value: "LinkedIn"},
    {label: "Twitter", value: "Twitter"},
    {label: "YouTube", value: "YouTube"},
    {label: "Facebook", value: "Facebook"},
    {label: "Instagram", value: "Instagram"},
    {label: "Snapchat", value: "Snapchat"},
    {label: "Pinterest", value: "Pinterest"},
    {label: "TikTok", value: "TikTok"},
]

export const DEFAULT_BUSINESS_TYPE = {
    farm: {
        label: "LABEL.BUSINESS_TYPE.FARM",
        value: "farm",
        active: true,
    },
    factory: {
        label: "LABEL.BUSINESS_TYPE.FACTORY",
        value: "factory",
        active: false
    },
    retailer: {
        label: "LABEL.BUSINESS_TYPE.RETAILER",
        value: "retailer",
        active: false
    },
    warehouse: {
        label: "LABEL.BUSINESS_TYPE.WAREHOUSE",
        value: "warehouse",
        active: false
    },
    distributor: {
        label: "LABEL.BUSINESS_TYPE.DISTRIBUTOR",
        value: "distributor",
        active: false
    },
    other: {
        label: "LABEL.BUSINESS_TYPE.OTHER",
        value: "other",
        active: false
    }
}
